import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3Button from "../../../core/et3-button";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getWebPayments from "../../../stores/auditor-store/web-payments";
import WebPaymentsForm from "./web-payments-form";
import WebPaymentsData from "./web-payments-data";

const WebPayments = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_WEB_PAYMENTS",
      "AUDITOR_WEB_PAYMENTS"
    );
  }, []);
  const isButtonDisabled = getWebPayments().isGetWebPaymentDisabled.get();

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("AUDITOR_WEB_PAYMENTS")}
        subTitle={i18n.get("SHOW_WEB_PAYMENTS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <WebPaymentsForm />

      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={isButtonDisabled}
        onClick={() => {
          getWebPayments().getWebPaymentsTable();
        }}
        size="LARGE"
        type="GET"
        text="GET"
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <WebPaymentsData />
    </ET3PageDiv>
  );
});
export default WebPayments;
